<template>

    <div class="product__comercial text-center position-relative overflow-hidden">

        <Particles
            class="position-absolute top-0 start-0 w-100 h-100"
            id="tsparticles"
            :particlesInit="particlesInit"
            :particlesLoaded="particlesLoaded"
            :options="{
                fullScreen: {
                    enable: false,
                    zIndex: -1,
                },
                fpsLimit: 120,
                particles: {
                    number: {
                        value: 12,
                    },
                    shape: {
                        type: 'char',
                        character: [
                            {
                                value: '\uf77c', // bebe
                                font: 'Font Awesome 6 Pro',
                                weight: '100'
                            },
                            {
                                value: '\ue673', // biberon
                                font: 'Font Awesome 6 Pro',
                                weight: '100'
                            },
                            {
                                value: '\uf77d', // carriola
                                font: 'Font Awesome 6 Pro',
                                weight: '100'
                            },
                            {
                                value: '\ue31e', //mom
                                font: 'Font Awesome 6 Pro',
                                weight: '100'
                            }
                        ]
                    },
                    opacity: { value: 0.6 },
                    size: { value: 20 },
                    move: {
                        enable: true,
                        speed: 1,
                        direction: 'bottom',
                        outMode: 'out'
                    }
                },
                detectRetina: true
            }"
        />


        <div class="position-relative z-1 d-flex justify-content-center align-items-center w-100 h-100 px-4 px-lg-0">
            <slot name="commercial-banner" v-bind="this"></slot>
        </div>


    </div>

</template>

<script>

import AOS from 'aos';
import 'aos/dist/aos.css';
import { loadFull } from "tsparticles";

export default {

    methods: {
        particlesInit(engine) {
            return loadFull(engine)
                .then(() => {
                    return engine;
                })
                .catch((error) => {
                    throw error;
                });
        },

        particlesLoaded(container) {
            return Promise.resolve(container);
        }
    },


    mounted() {
        AOS.init({
            once: true,
            duration: 1500
        })
    },

}
</script>
